export default __webpack_public_path__ + "static/media/RhymesBedtime_03.bc496737.png";